export default __webpack_public_path__ + "static/media/projecticon-01.2d7bd87e.png";